import { Marquee } from "@/components/ui/marquee";
import { animate, useInView, useReducedMotion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

// Order keeps ctslabs and collectibletags (same logo) apart, including across
// the loop seam where the last item sits next to the first.
const TRUSTED_SELLERS = ["ctslabs", "krakenhits", "collectibletags", "spacenarwhalz"];

const TRUSTED_FOLLOWERS_K = 800;

export function TrustedByMarquee() {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const reduceMotion = useReducedMotion();
  const [followersK, setFollowersK] = useState(0);

  useEffect(() => {
    if (!inView) return;
    if (reduceMotion) {
      setFollowersK(TRUSTED_FOLLOWERS_K);
      return;
    }
    const controls = animate(0, TRUSTED_FOLLOWERS_K, {
      duration: 1.8,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setFollowersK(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, reduceMotion]);

  return (
    <section className="mx-auto max-w-4xl px-6 pb-16" data-testid="landing-trusted-by">
      <p className="text-center text-xs font-medium tracking-widest text-muted-foreground uppercase">
        Trusted by sellers with over{" "}
        <span
          ref={ref}
          className="text-foreground tabular-nums"
          data-testid="landing-trusted-by-followers"
        >
          {followersK}k
        </span>{" "}
        followers
      </p>
      <Marquee
        pauseOnHover
        className="mt-6 [mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)]"
      >
        {TRUSTED_SELLERS.map((seller) => (
          <a
            key={seller}
            href={`https://www.whatnot.com/user/${seller}`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 text-muted-foreground transition-colors hover:text-foreground"
            data-testid={`landing-trusted-seller-${seller}`}
          >
            <img
              src={`/trusted-sellers/${seller}.jpeg`}
              alt={`${seller} logo`}
              className="size-7 rounded-full border object-cover"
              loading="lazy"
            />
            <span className="text-sm font-semibold whitespace-nowrap">{seller}</span>
          </a>
        ))}
      </Marquee>
    </section>
  );
}
